// extracted by mini-css-extract-plugin
export default {"search-field":"GeoNorgeNavnSearch_search-field__3gImH","search-results":"GeoNorgeNavnSearch_search-results__IkUPo"};